import ContactsBanner from './images/ContactsBanner.jpg';
import Ship from './images/ship.jpeg';
import BackgroundVideo from './videos/background.mp4';
import './App.css';
import { Col, Row, Button, Typography} from 'antd';
import {NavLink} from "react-router-dom";
import Header from "./Header";

const { Title, Text } = Typography;

function Home() {
  return (
    <>
    <div style={{
                    backgroundImage: `url(${ContactsBanner})`,
                    minHeight: '800px',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                }}>
                  <video
                    autoPlay
                    muted
                    // loop
                    playsInline
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover"
                    }}
                  >
                    <source src={BackgroundVideo} type="video/mp4" />
                  </video>
        <Header />

        <Row style={{
                  maxWidth: 1280,
                  margin: '0 auto',
                  padding: 24
                }}>
        <Col span={12} className='Header'>
          <h1 style={{fontSize: '5em',textShadow: '3px 3px 24px white'}}>Living & Beyond</h1>

          <h3 style={{textShadow: '3px 3px 24px white'}}>This is your palce to stay, redefined. Get powerful daily housing offers and global freedom. Sign up for free in a tap.</h3>
<br /><br /><br />
 <NavLink className={"menu"} to={'/register'}>
          <Button size="large" color="default" variant="solid">Connect</Button>
          </NavLink>

        </Col>
        <Col span={12}></Col>
      </Row>
      </div>
      <Row style={{
                  maxWidth: 1280,
                  margin: '0 auto',
                  padding: 24,
                  textAlign: 'center',
                  paddingTop: 128,
                  minHeight: 440
                }}>
        <Col span={24}>
          <Title level={1}>Your staying, reimagined</Title>

          <Title level={4} style={{fontWeight: "normal"}}>Live smartly, move quickly, sort utilities automatically, and watch your life 
            become <br />as easy as it gets — all with a StorkStay.</Title>
            <br />
            <NavLink className={"menu"} to={'/register'}>
              <Button size="large" color="default" variant="solid">Sign up</Button>
            </NavLink>

        </Col>
      </Row>

      <Row
          style={{
                  maxWidth: 1024,
                  margin: '0 auto'
                }}
            >
                <Col
                    span={12}
                    style={{ textAlign: "left", paddingRight: 48 }}
                    className={'cloud'}
                >
                    <Title level={1} style={{ marginBottom: 32, marginTop: 220 }}>Our mission</Title>
                    <Title level={4} style={{fontWeight: "normal" }}>Our mission is to provide inspiring co-living environments where people can live comfortably, connect naturally and grow together.</Title>
                </Col>
                <Col span={12}>
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${ContactsBanner})`,
                        backgroundPosition: 'right',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: "600px",
                        position: "relative",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Small & Medium Business</h1>
                            <Text style={{float: "right", paddingTop: 8}} type="secondary">
                              {/* <img src={AmberFinLogo} style={{ maxWidth: '18px' }} alt={''} /> */}
                              </Text>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row style={{
                maxWidth: 1024,
                margin: '24px auto 124px auto',
                textAlign: "center"
            }}>
                                   

                <Col span={24}>
                    <Title level={1} style={{marginTop: 128}}>Why us?</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>
                        We combine modern co-living operations with smart technology — delivering seamless tenant<br/> management, automated workflows and a better living <br/> experience for residents.</Title>
                </Col>
            </Row>

            <Row
                style={{
                    maxWidth: 1024,
                    margin: '0 auto 148px auto'
                }}
            >
                <Col span={12}>
                
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${Ship})`,
                        backgroundPosition: 'left',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: "600px",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Enterprise Business Solutions </h1>
                            <Text style={{float: "right", paddingTop: 8}} type="secondary">
                            </Text>
                        </div>
                    </div>
                </Col>
                <Col
                    span={12}
                    style={{ textAlign: "left", paddingLeft: 48 }}
                    className={'cloud'}
                >
                    <Title level={1} style={{ marginBottom: 32, marginTop: 220 }}>What do we do</Title>
                    <Title level={4} style={{fontWeight: "normal" }}>We provide technology-driven co-living solutions that 
                      simplify property management, automate daily operations and improve the resident experience.</Title>
                </Col>
            </Row>
    </>
  );
}

export default Home;